import { CompletionType } from 'root/src/shared/rewards/constants';
export const isProjectSubmittable = (project) => {
    var _a;
    return ((_a = project.completion) === null || _a === void 0 ? void 0 : _a.type) !== CompletionType.GAME_INTEGRATED;
};
